import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class PaymentRequestService {
	// domain = environment.production ? 'focuslink.focuspos.com' : 'dev.focuslink.focuspos.com';
	// baseUrl = `https://${this.domain}/v2`;
	// paymentDetails: PaymentDetailsInit;
	// paymentMethods: PaymentMethodData[] = [
	//     {
	//         supportedMethods: 'basic-card',
	//         data: {
	//             supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
	//             supportedTypes: ['credit', 'debit', 'prepaid'],
	//         },
	//     },
	//     // {
	//     //     supportedMethods: 'https://apple.com/apple-pay',
	//     //     data: {
	//     //         version: 3,
	//     //         merchantIdentifier: 'merchant.com.focuspos.pay',
	//     //         merchantCapabilities: [
	//     //             'supports3DS',
	//     //             'supportsCredit',
	//     //             'supportsDebit',
	//     //         ],
	//     //         supportedNetworks: ['amex', 'discover', 'mastercard', 'visa'],
	//     //         countryCode: 'US',
	//     //     },
	//     // },
	//     // {
	//     //   supportedMethods: 'https://google.com/pay',
	//     //   data: {
	//     //     supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
	//     //     supportedTypes: ['credit', 'debit', 'prepaid']
	//     //   }
	//     // },
	// ];
	// paymentOptions: PaymentOptions = {
	//     requestPayerEmail: true,
	//     requestPayerPhone: true,
	//     requestPayerName: true
	// };
	// request: any;
	// constructor(
	//     private http: HttpClient,
	//     private deviceService: DeviceDetectorService
	// ) { }
	// async getApplepayMerchantSession(validationURL: string, initiativeContext: string) {
	//     return await this.http.get(`${this.baseUrl}/payments/applepay/merchantsession?validationURL=${validationURL}&initiativeContext=${initiativeContext}`).toPromise();
	// }
	// init(paymentDetails: PaymentDetailsInit, shippingType?: string) {
	//     if (this.isAvailable) {
	//         this.paymentDetails = paymentDetails;
	//         if (shippingType) {
	//             this.paymentOptions.requestShipping = true;
	//             this.paymentOptions.shippingType = shippingType;
	//         } else {
	//             this.paymentOptions.requestShipping = false;
	//         }
	//         this.request = new PaymentRequest(this.paymentMethods, this.paymentDetails, this.paymentOptions);
	//         this.request.addEventListener('shippingaddresschange', (event: PaymentRequestUpdateEvent) => {
	//             event.updateWith(this.paymentDetails);
	//         });
	//         this.request.onmerchantvalidation = async event => {
	//             const validationURL = `${event.validationURL}`
	//             const initiativeContext = environment.production ? 'onlineorder.focuspos.com' : 'dev.onlineorder.focuspos.com';
	//             const session = await this.getApplepayMerchantSession(validationURL, initiativeContext);
	//             event.complete(session);
	//         };
	//         return this.request;
	//     }
	// }
	// isAvailable() {
	//     let isAvailable = false;
	//     let paymentRequest = window.PaymentRequest ? true : false;
	//     // const ua = navigator.userAgent;
	//     // let chromeAgent = ua.indexOf("Chrome") > -1;
	//     // let IExplorerAgent = ua.indexOf("MSIE") > -1 || ua.indexOf("rv:") > -1;
	//     // let edgeAgent = ua.indexOf("Edge") > -1;
	//     // let firefoxAgent = ua.indexOf("Firefox") > -1;
	//     // let operaAgent = ua.indexOf("OP") > -1;
	//     // let safariAgent = ua.indexOf("Safari") > -1;
	//     // if ((chromeAgent) && (safariAgent)) safariAgent = false;
	//     const deviceInfo = this.deviceService.getDeviceInfo();
	//     const browser = deviceInfo.browser;
	//     console.log('Browser', browser);
	//     if (paymentRequest && browser.toLocaleLowerCase() === 'chrome') {
	//         isAvailable = true;
	//     }
	//     return isAvailable;
	// }
	// async show(paymentDetails: PaymentDetailsInit, shippingType?: string): Promise<PaymentResponse> {
	//     const request = this.init(paymentDetails, shippingType);
	//     if (request) {
	//         try {
	//             const response = await request.show();
	//             response.complete('success');
	//             return response;
	//         } catch (error) {
	//             console.error(error);
	//         }
	//     }
	// }
}
